<!-- =========================================================================================
    File Name: UserEmailsSentList.vue
    Description: Emails sent to the user with preview of email
    ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
    <div>
        <vs-button :type="btnConfig.type" :color="btnConfig.color" :size="btnConfig.size" v-on:click="getEmailsList()">Correos enviados</vs-button>
        <!-- LISTA DE CORREOS ENVIADOS AL USUARIO -->
        <!-- POP UP EXTENDIDO -->
        <vs-popup class="extended-popup header-primary" title="Lista de correos enviados al usuario en los últimos 45 días" :active.sync="showModalList">
            <vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-full">
                        <vs-table
                        ref="emailsTable"
                        stripe
                        search
                        pagination 
                        max-items="20"
                        :data="allEmailsData.messages"
                        noDataText="No se econtraron emails de este usuario"
                        >
                        <template slot="header">
                          <h4 class="pill-light">Email: {{userEmail}} </h4>
                        </template>
                        <template slot="thead">
                            <vs-th>Estatus</vs-th>
                            <!-- <vs-th>Asunto</vs-th> -->
                            <vs-th>Tag</vs-th>
                            <vs-th>Fecha</vs-th>
                            <vs-th>Vista previa</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr
                            :key="indextr"
                            v-for="(tr, indextr) in data"
                            :data="tr"
                            >
                                <vs-td><label :class="setStatusPillClass(tr.status)">{{ tr.status }}</label></vs-td>
                                <!-- <vs-td>{{ tr.subject }}</vs-td> -->
                                <vs-td><label class="pill-light">{{ tr.tag }}</label></vs-td>
                                <vs-td>{{ logDateFormat12Format(tr.received_at) }}</vs-td>
                                <vs-td><vs-button radius color="success" icon-pack="feather" icon="icon-play" v-on:click="getMessageDetail(tr.message_id)"></vs-button></vs-td>
                            </vs-tr>
                        </template>
                        </vs-table>
                    </div>
                </div>
            </vx-card>
        </vs-popup>
    </div>
</template>

<script>
import formatHelper from '@components/mixins/formatHelper';
import dateHelper from '@components/mixins/dateHelper';

export default{
  name: 'user-emails-sent-list',
  props: {
    userEmail: {
      type:[String],
      required: true
    },
    emailStream: {
      type:[String],
      default: "outbound"
    },
    // Prop para cambiar apariencia de botón.
    btnConfig: {
        type: Object,
        required: false,
        default: () => ({
          color: "dark",
          size: "small",
          type: "filled"
        })
    }
  },
  mixins: [formatHelper,dateHelper],
  data () {
    return {
        allEmailsData:{
            total: 0,
            count: 0,
            messages: []
        },
        showModalList:false,
        showModalDetail:false,
        currentMessageData:{
            message_id: 0,
            html_body: "",
            received_at: null 
        }
    }
  },
  methods: {
    async getEmailsList(){
      this.showLoading(true);
      let url = `/api/user-email-sent-list`;
      await axios.post(url, {
          email: this.userEmail,
          stream: this.emailStream,
      }).then(response => {
        this.allEmailsData = response.data;
        this.showLoading(false);
        this.showModalList=true;
      }).catch(error => {
        this.showLoading(false);
      });
    },
    async getMessageDetail(messageId){
      const url = `${this.ApiDomain}/api/email/outbound/messageDetail/${messageId}?access_token=${this.AccessToken}`;
      window.open(url,url,'addressbar=0,directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=0,resizable=0');
    },
    setStatusPillClass(status){
      let pill = "";
      switch (status) {
        case "bounce":
          pill = "pill-warning";
          break;
        case "spam_complaint":
          pill = "pill-danger";
          break;
        case "open":
          pill = "pill-blue";
          break;
        case "delivery":
          pill = "pill-success";
          break;
        case "click":
          pill = "pill-purple";
          break;
        default:
          break;
      }
      return pill;
    },
  }
}
</script>